export default __webpack_public_path__ + "static/media/litecoin.5f984656.png";